import { uiLangIsRtl } from "@/l11n/l11n";
import ImageWidget from "./ImageWidget";

export default function ChatMessage({ message }) {
  const msgDirectionality = message.directionality;
  const isRtl = (msgDirectionality && msgDirectionality === "rtl") ?? uiLangIsRtl();

  return (
    <div
      className={`flex flex-col ${
        message.senderId === "user" ? "items-end" : "items-start"
      }`}
    >
      {message.senderId !== "user" && (
        <div className="text-xs text-muted-foreground mb-1">Taalia</div>
      )}
      <div
        className={`inline-block rounded-lg px-3 py-2 ${
          message.senderId === "user"
            ? "bg-primary_diffuse text-primary-foreground"
            : "bg-muted"
        }`}
        style={{
          maxWidth: "75%",
          boxSizing: "border-box",
          textAlign: isRtl ? "right" : "left",
          direction: isRtl ? "rtl" : "ltr",
          wordBreak: "break-word",
          overflowWrap: "break-word",
        }}
      >
        <div
          className="prose text-sm leading-normal max-w-none"
          dangerouslySetInnerHTML={{ __html: message.utterance }}
        />
        {message.subutterance && (
          <div className="mt-2 mb-1">
            <hr className="mb-2" />
            <div className="text-sm mr-2 ml-2" style={{ color: "hsl(0, 0%, 35%)" }}>
              {message.subutterance}
            </div>
          </div>
        )}
        {message.content?.url && (
          <ImageWidget url={message.content.url} maxWidth="100%" maxHeight="100%" />
        )}
      </div>
    </div>
  );
}
